import apiClient from "./api-client.service";
import { NotificationReminder } from "../Interface/Index";
import {
  CreateNotificationReminderDto,
  UpdateNotificationReminderDto,
} from "../Interface/dtos";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";

class NotificationReminderService {
  async getRemindersBySessionId(
    sessionId: string,
  ): Promise<NotificationReminder[] | null> {
    try {
      const response = await apiClient.get(
        `${API_BASE_URL}/notification/reminder/session/${sessionId}`,
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "NotificationReminderService ~ getRemindersBySessionId ~ error:",
        error,
      );
      return null;
    }
  }

  async createNotificationReminder(
    dto: CreateNotificationReminderDto,
  ): Promise<NotificationReminder | null> {
    try {
      const response = await apiClient.post(
        `${API_BASE_URL}/notification/reminder`,
        dto,
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "NotificationReminderService ~ createNotificationReminder ~ error:",
        error,
      );
      return null;
    }
  }

  async updateNotificationReminder(
    id: string,
    dto: UpdateNotificationReminderDto,
  ): Promise<NotificationReminder | null> {
    try {
      const response = await apiClient.patch(
        `${API_BASE_URL}/notification/reminder/${id}`,
        dto,
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "NotificationReminderService ~ updateNotificationReminder ~ error:",
        error,
      );
      return null;
    }
  }
}

const notificationReminderService = new NotificationReminderService();

export default notificationReminderService;
